const TABS = [
  { id: 'scan', label: 'Σκανάρισμα', emoji: '📲' },
  { id: 'map', label: 'Χάρτης', emoji: '🗺️' },
  { id: 'dashboard', label: 'Dashboard', emoji: '📊' },
  { id: 'rewards', label: 'Επιβραβεύσεις', emoji: '🎁' },
  { id: 'profile', label: 'Προφίλ', emoji: '👤' },
]

export default function BottomNav({ active, onChange }) {
  return (
    <nav style={s.nav}>
      {TABS.map(tab => (
        <button
          key={tab.id}
          style={{ ...s.btn, ...(active === tab.id ? s.btnActive : {}) }}
          onClick={() => onChange(tab.id)}
        >
          <span style={s.emoji}>{tab.emoji}</span>
          <span style={s.label}>{tab.label}</span>
        </button>
      ))}
    </nav>
  )
}

const s = {
  nav: { position: 'fixed', bottom: 0, left: 0, right: 0, background: 'white', borderTop: '1px solid #f0f0f0', display: 'flex', zIndex: 50, paddingBottom: 'env(safe-area-inset-bottom)' },
  btn: { flex: 1, padding: '8px 0', border: 'none', background: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 },
  btnActive: { color: '#1A6B3C' },
  emoji: { fontSize: 18 },
  label: { fontSize: 9, color: 'inherit' },
}
